import { Button, Result } from 'antd';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from './AppContext';
import { PERMISSION_TYPE, ROUTES, USER_ROLES } from './common/constants';
import { hasPermission } from './common/utils';

const AccessControl = ({
  children,
  permissionKey,
  permissionType = PERMISSION_TYPE?.READ,
  noButton,
  errorSubTitle,
  allowedRoles,
}) => {
  const {
    state: { permissions, currentUser },
  } = useContext(AppContext);
  const history = useHistory();

  const hasAccess = hasPermission(permissionKey, permissionType, permissions);
  const hasAllowedRole =
    !allowedRoles?.length ||
    currentUser?.roles?.some((role) => allowedRoles?.includes(role));

  if (
    !hasAllowedRole ||
    (!hasAccess &&
      !currentUser?.roles?.includes(USER_ROLES?.LIBRARIAN?.key) &&
      !currentUser?.roles?.includes(USER_ROLES?.SALES?.key))
  ) {
    return (
      <Result
        status="403"
        title="403"
        subTitle={
          errorSubTitle || 'Sorry, you are not authorized to access this page.'
        }
        extra={
          !noButton && (
            <Button type="primary" onClick={() => history?.push(ROUTES?.MAIN)}>
              Back Home
            </Button>
          )
        }
      />
    );
  }

  return <div>{children}</div>;
};

export default AccessControl;
